import {register} from '../modules/eventMap';

function fire(el) {
    const form = el.closest('form');
    const button = form.querySelector('button');
    button.click();
}

const submitOnChange = () => {
    register('submitOnChange', {
        fire
    });
};

export {submitOnChange};
